<template>
  <div>
    <div v-if="state < 2">
      <div v-if="clientState < 2">
        {{ defaultPosition | positionToString }}
        <span v-if="bottomUser">{{bottomUser.username}}</span>
        <span v-else>
          <br />
          <button
            v-if="clientState == 1"
            class="button is-small is-info mt-2"
            v-on:click="sitHere(defaultPosition)"
          >SIT</button>
        </span>
      </div>
      <div v-if="clientState == 2">
        <div>{{ user.position | positionToString }} {{ user.username }}</div>
        <br />
        <button
          v-if="clientState == 2 && state == 1"
          class="button is-small is-info mt-2"
          v-on:click="sitHere(-1)"
        >STAND</button>
      </div>
    </div>
    <div class="modal" v-bind:class="{'is-active': showEmoji}">
      <div class="modal-background"></div>
      <EmojiComponent v-on:close-emoji="showEmoji = false"></EmojiComponent>
    </div>
    <div v-if="game && state >= 2">
      <div v-if="clientState == 2 && user">
        <div
            style="height: 32px;"
          >
           <div style="position: absolute; font-size: 1.5rem; margin-left: 20rem;">
               <span class="icon has-text-grey-lighter" v-on:click="showEmoji=true">
               <i class="far fa-grin"></i>
               </span>
             </div>
            <button class="button is-small is-info" v-if="state == 3 && user.position == game.currentTurn && clientState == 2"
            v-bind:class="{'disabled': selectedCard == ''}"
             v-on:click="sendCard()">SEND</button>            
             <div v-if="emoji" style="position: absolute; z-index: 999;">
              <div class="bottom-emoji">{{emoji}}</div>
            </div>
          </div>
        <!-- <div v-else>{{ user.position | positionToString }} {{ user.username }}</div> -->
        <div style="max-width: 320px; margin: 0 auto;">
          <div
            v-if="state == 2 || state == 3 || state == 4"
            style="margin-left: -68px; margin-top: 24px;"
          >          
            <div
              style="display: inline;"
              v-for="card in displayedHand"
              v-bind:key="rand() + card"
            >
              <div
                style="display: inline;"
                v-on:click="selectedCard = card == selectedCard ? '' : card"
              >
                <span v-if="card == 'AD'">
                      <img
                    class="img-card enabled-card"
                    style="height: 140px; margin-right: -68px;"
                    v-bind:class="{
                        'selected-card': selectedCard == card,
                        'disabled-card': suitOnly && card.indexOf(game.currentSuit) == -1
                        }"
                    :src="require(`@/assets/cards/AceDiamond.png`)"
                  />
                </span>
                <span v-else>
                  <img
                    class="img-card enabled-card"
                    style="height: 140px; margin-right: -68px;"
                    v-bind:class="{
                        'selected-card': selectedCard == card,
                        'disabled-card': suitOnly && card.indexOf(game.currentSuit) == -1
                        }"
                    :src="require(`@/assets/cards/${card}.png`)"
                  />
                </span>
              </div>
            </div>
          </div>
          <div>{{ user.position | positionToString }} {{ user.username }}</div>
        </div>
      </div>
      <div v-if="clientState < 2 && bottomUser">
        <!-- Game started, user not joined -->
        <div style="margin: 0 auto;">
          <div v-if="state == 2 || state == 3 || state == 4">
            <div v-if="emoji" style="position: absolute;">
              <div class="bottom-emoji">{{emoji}}</div>
            </div>
            <div style="display: inline;" v-for="card in bottomUser.hand" v-bind:key="rand + card">
              <div v-if="state == 2 || state == 3" class="game-card upper back"></div>
              <div
                v-if="state == 4"
                class="side-card lower"
                v-bind:class="{ 'has-text-danger': card.indexOf('H') > 0 || card.indexOf('D') > 0, }"
              >
                {{ card | getNumber }}
                <br />
                {{ card | getSuit }}
              </div>
            </div>
          </div>
        </div>
        <div>{{ bottomUser.position | positionToString }} {{ bottomUser.username }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import socketStore from "@/service/socketStore";
import EmojiComponent from "@/components/EmojiComponent.vue";

export default {
  name: "BottomComponent",
  components: {
    EmojiComponent
  },
  props: {
    user: Object,
    bottomUser: Object,
    state: Number,
    game: Object,
    defaultPosition: Number,
    clientState: Number,
    emoji: String
  },
  data: () => {
    return {
      selectedCard: "",
      showEmoji: false,
    };
  },
  computed: {
    suitOnly: function () {
      if (
        this.game.currentSuit &&
        this.user.hand.findIndex((p) => p.indexOf(this.game.currentSuit) > -1) >
          -1
      ) {
        return true;
      }
      return false;
    },
    displayedHand: function() {
      var temp = [];
      if(this.user.hand) {
        temp = [...this.user.hand];
        temp = temp.sort((a, b) => {
          var cardOrder = ["C","D"];
          var aSuit = a.substr(a.length - 1, 1);
          var bSuit = b.substr(b.length - 1, 1);
          var aIndex = cardOrder.indexOf(aSuit);
          var bIndex = cardOrder.indexOf(bSuit);
          return bIndex < aIndex ? -1 : bIndex < aIndex ? 1 : 0;
        })
      }
      return temp;
    }
  },
  methods: {
    rand() {
      return Math.random().toString(36).substring(7);
    },
    sendCard: function () {
      socketStore.emit("send_card", this.selectedCard);
    },
    sitHere: function (position) {
      socketStore.emit("set_position", position);
    },
  },
};
</script>

<style>
.selected-card {
  margin-top: -20px !important;
  margin-bottom: 20px;
}
.bottom-emoji {
  margin-left: 10rem;
  margin-top: 1rem;
  background: white;
  border-radius: 50%;
  padding: 2px;
  width: 70px;
  height: 70px;
  box-shadow: 0px 2px 3px grey;
  font-size: 3rem;
}
</style>